var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"start"},[_c('div',{staticClass:"tomrum"}),(_vm.vyNummer%2 == 0)?_c('Vy1'):_vm._e(),(_vm.vyNummer%2 == 1)?_c('Vy2'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }